import { Drawer } from '@chakra-ui/react';

import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import { CloseButton } from 'shared/components/Button/CloseButton';

const SidebarMainHeaderCloseButton = () => (
  <Drawer.CloseTrigger
    asChild
    pos="initial"
    data-testid="notes-sidebar-close-btn"
  >
    <CloseButton variant="ghost">
      <Icon name={iconNames.chevronRight} />
    </CloseButton>
  </Drawer.CloseTrigger>
);

export default SidebarMainHeaderCloseButton;
